export { default as Login } from './Login';
export { default as FormLogin } from './FormLogin';
export { default as FormRegistrar } from './FormRegistrar';
export { default as FormResetPassword } from './FormResetPassword';
export { default as AlterarSenha } from './AlterarSenha';
export { default as FormAlterarSenha } from './FormAlterarSenha';
export { default as Logout } from './Logout';



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/index.js